import Vue from 'vue';
import Vuex from 'vuex';
import USER from './modules/user.js';
Vue.use(Vuex);

// import getModuleState from './modules/list.js';

// const NEWS = getModuleState({
//     TYPE: 'news',
// });

const moduleList = [
    'news',
    'tags',
    'launches',
    'satellites',
    'constellations',
    'instruments',
    'launchsites',
    'organ',
    'countries',
];

const modules = {
    USER,
};

// moduleList.forEach(type => {
//     modules[type.toUpperCase()] = getModuleState({
//         TYPE: type,
//     });
// });

const store = new Vuex.Store({
    modules,
    state: {},
    getters: {},
    mutations: {
        SET_STATE(state, { key, value }) {
            state[key] = value;
        },
    },
    actions: {},
});

export default store;
